import axios from 'axios';
export const commSettingsForDynDash = {
  // ==========master ==============

  showMaster: (id: string) =>
    axios.get(`/MasterCommunication/master?masterId=${id}`),

  //    =============== Communction =========

  showCommunication: (id: string) =>
    axios.get(`/MasterCommunication?communicationId=${id}`),
  addCommunication: (params: any) =>
    axios.post(`/MasterCommunication/addCommunication`, params),
  updateCommunication: (params: any) =>
    axios.put(`/MasterCommunication`, params),
  deleteCommunication: (id: string) =>
    axios.delete(`/MasterCommunication?communicationId=${id}`),
  showDynDashCommunication: (assetId: string, masterId: string) =>
    axios.post(
      `/MasterCommunication/dynamicDashboard?assetId=${assetId}&masterId=${masterId}`,
    ),

  // =================== Notification ==========

  addNotification: (id: string, params: any) =>
    axios.post(
      `/MasterCommunication/addNotification?communicationId=${id}`,
      params,
    ),
  deleteNotification: (id: string) =>
    axios.delete(`/MasterCommunication/notification?notificationId=${id}`),
};
